export const SPACING = 1;

export const CORNER_RADIUS = '3px';

// font size
export const CALCULATOR_FONT = 20

// image size
export const SQURE_FLAG_SIZE = 30

// shadow image size
export const SHADOW_FLAG_SIZE = 42